import { c as _c } from "react/compiler-runtime";
import { type SxProps } from '@mui/material';
import { getIconStyles } from '../getIconStyles';
export const BaseIcon = t0 => {
  const $ = _c(6);
  const {
    Icon,
    onClick
  } = t0;
  const t1 = !!onClick;
  let t2;
  if ($[0] !== t1) {
    t2 = getIconStyles({
      clickable: t1
    });
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const styles = t2;
  let t3;
  if ($[2] !== Icon || $[3] !== onClick || $[4] !== styles) {
    t3 = <Icon onClick={onClick} sx={styles} />;
    $[2] = Icon;
    $[3] = onClick;
    $[4] = styles;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};